//#region types
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { TranslationKeys } from "translations";
import { DialogEnums, StyleEnums } from "models/enums";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import { useCustomerService } from "serviceHooks";

function useRemoveCustomerDialog() {
  const customerService = useCustomerService();
  const onDeleteCustomer = (id: number) => {
    return customerService.deleteCustomer(id);
  };

  const removeCustomerDialog = (customerId: number, onSubmitSuccess?: () => void): DialogProps => {
    return {
      isOpen: false,
      id: "removeCustomer",
      title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Customer.RemoveCustomerTitle),
      dialogType: DialogEnums.DialogType.Message,
      titleIcon: IconDefinitionConstants.WTrashAlt,
      type: StyleEnums.DisplayType.Danger,
      children: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Customer.RemoveCustomerDescriptionText),
      actions: [
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Remove),
          successMessage: TranslationKeys.Customer.RemoveCustomerSuccess,
          type: StyleEnums.DisplayType.Danger,
          onClick: () => onDeleteCustomer(customerId),
        },
      ],
      onSubmit: onSubmitSuccess,
      maxWidth: "sm",
    };
  };

  return removeCustomerDialog;
}

export default useRemoveCustomerDialog;
